import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useModule } from "../../hooks/useModules";

const LABELS = {
  module_pointage: "Pointage",
  module_planning: "Planning",
  module_rh: "RH",
  module_maintenance: "Maintenance",
  module_stock: "Stock",
};

/**
 * Garde de route par module d'abonnement.
 * - chargement : spinner discret
 * - module actif : rend les enfants
 * - module inactif : écran d'upsell vers l'abonnement
 */
export default function ModuleRoute({ module, children }) {
  const { enabled, isLoading } = useModule(module);

  if (isLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-4 border-brand border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!enabled) {
    const label = LABELS[module] || "Ce module";
    return (
      <div className="max-w-md mx-auto text-center py-16 px-4" data-testid="module-locked">
        <div className="h-12 w-12 rounded-full bg-secondary grid place-items-center mx-auto mb-4">
          <Lock className="h-5 w-5 text-muted-foreground" />
        </div>
        <h1 className="text-xl font-semibold text-foreground">{label} non inclus</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Ce module n'est pas disponible dans votre abonnement actuel.
        </p>
        <Link
          to="/settings/billing"
          className="inline-block mt-5 bg-primary text-primary-foreground rounded-lg px-4 py-2 text-sm font-semibold"
        >
          Voir les abonnements
        </Link>
      </div>
    );
  }

  return children;
}
